module.exports = __webpack_public_path__ + "static/img/7.3f812c65.png";